/**
 * Product Offering Endpoints
 */

export const apiPostProductOffering = async (
  productOffering: ProductOfferingCreateUpdate,
): Promise<AxiosResponse<ProductOffering>> => {
  return await userManagementAxiosInstance.post('product_offerings', productOffering);
};

export const apiGetProductOfferings = async (
  limit: number = defaultLimit,
  offset: number = defaultOffset,
): Promise<AxiosResponse<PaginatedProductOffering>> => {
  return await userManagementAxiosInstance.get(`product_offerings?limit=${limit}&offset=${offset}`);
};

export const apiGetProductOffering = async (
  id: string | number,
): Promise<AxiosResponse<ProductOffering>> => {
  return await userManagementAxiosInstance.get(`product_offerings/id/${id}`);
};

export const apiPutProductOffering = async (
  productOffering: ProductOfferingCreateUpdate,
): Promise<AxiosResponse<ProductOffering>> => {
  return await userManagementAxiosInstance.put(
    `product_offerings/id/${productOffering.id}`,
    productOffering,
  );
};

export const apiDeleteProductOffering = async (
  id: string | number,
): Promise<AxiosResponse<ProductOffering>> => {
  return await userManagementAxiosInstance.delete(`product_offerings/id/${id}`);
};

/**
 * Product Component Link Endpoints
 */

export const apiPostProductComponentLink = async (
  id: string | number,
  productComponentId: string | number,
): Promise<AxiosResponse<ProductComponent>> => {
  return await userManagementAxiosInstance.post(
    `product_offerings/id/${id}/product_components/${productComponentId}`,
  );
};

export const apiGetProductComponentLinks = async (
  id: string | number,
  limit: number = defaultLimit,
  offset: number = defaultOffset,
): Promise<AxiosResponse<PaginatedProductComponent>> => {
  return await userManagementAxiosInstance.get(
    `product_offerings/id/${id}/product_components?limit=${limit}&offset=${offset}`,
  );
};

export const apiGetProductComponentLink = async (
  id: string | number,
  productComponentId: string | number,
): Promise<AxiosResponse<ProductComponent>> => {
  return await userManagementAxiosInstance.get(
    `product_offerings/id/${id}/product_components/${productComponentId}`,
  );
};

export const apiDeleteProductComponentLink = async (
  id: string | number,
  productComponentId: string | number,
): Promise<AxiosResponse<ProductComponent>> => {
  return await userManagementAxiosInstance.delete(
    `product_offerings/id/${id}/product_components/${productComponentId}`,
  );
};

/**
 * Feature Link Endpoints
 */

export const apiGetFeatureLinks = async (
  id: string | number,
  limit: number = defaultLimit,
  offset: number = defaultOffset,
): Promise<AxiosResponse<FeatureLink[]>> => {
  return await userManagementAxiosInstance.get(
    `product_offerings/${id}/features?limit=${limit}&offset=${offset}`,
  );
};

export const apiPutFeatureLinks = async (
  id: string | number,
  features: {features: FeatureLink[]},
): Promise<AxiosResponse<FeatureLink[]>> => {
  return await userManagementAxiosInstance.put(`product_offerings/${id}/features`, features);
};

/**
 * Labor Component Link Endpoints
 */

export const apiPostLaborComponentLink = async (
  id: string | number,
  laborComponentId: string | number,
): Promise<AxiosResponse<LaborComponent>> => {
  return await userManagementAxiosInstance.post(
    `product_offerings/id/${id}/labor_components/${laborComponentId}`,
  );
};

export const apiGetLaborComponentLinks = async (
  id: string | number,
  limit: number = defaultLimit,
  offset: number = defaultOffset,
): Promise<AxiosResponse<PaginatedLaborComponent>> => {
  return await userManagementAxiosInstance.get(
    `product_offerings/id/${id}/labor_components?limit=${limit}&offset=${offset}`,
  );
};

export const apiGetLaborComponentLink = async (
  id: string | number,
  laborComponentId: string | number,
): Promise<AxiosResponse<LaborComponent>> => {
  return await userManagementAxiosInstance.get(
    `product_offerings/id/${id}/labor_components/${laborComponentId}`,
  );
};

export const apiDeleteLaborComponentLink = async (
  id: string | number,
  laborComponentId: string | number,
): Promise<AxiosResponse<LaborComponent>> => {
  return await userManagementAxiosInstance.delete(
    `product_offerings/id/${id}/labor_components/${laborComponentId}`,
  );
};

/**
 * Service Level Objective Link Endpoints
 */

export const apiPostServiceLevelObjectiveLink = async (
  id: string | number,
  serviceLevelObjectiveId: string | number,
): Promise<AxiosResponse<ServiceLevelObjective>> => {
  return await userManagementAxiosInstance.post(
    `product_offerings/id/${id}/service_level_objectives/${serviceLevelObjectiveId}`,
  );
};

export const apiGetServiceLevelObjectiveLinks = async (
  id: string | number,
  limit: number = defaultLimit,
  offset: number = defaultOffset,
): Promise<AxiosResponse<PaginatedServiceLevelObjective>> => {
  return await userManagementAxiosInstance.get(
    `product_offerings/id/${id}/service_level_objectives?limit=${limit}&offset=${offset}`,
  );
};

export const apiGetServiceLevelObjectiveLink = async (
  id: string | number,
  serviceLevelObjectiveId: string | number,
): Promise<AxiosResponse<ServiceLevelObjective>> => {
  return await userManagementAxiosInstance.get(
    `product_offerings/id/${id}/service_level_objectives/${serviceLevelObjectiveId}`,
  );
};

export const apiDeleteServiceLevelObjectiveLink = async (
  id: string | number,
  serviceLevelObjectiveId: string | number,
): Promise<AxiosResponse<ServiceLevelObjective>> => {
  return await userManagementAxiosInstance.delete(
    `product_offerings/id/${id}/service_level_objectives/${serviceLevelObjectiveId}`,
  );
};
